import LocalStorageConstants from '~/constants/LocalStorageConstants';
import {localStorageAvailable} from '~/utils/persistInLocalStorage';
import {DATA_MODEL_VERSION} from '~/constants/App';

let snapshot;
try {
  snapshot = localStorage.getItem(LocalStorageConstants.SNAPSHOT);
  const version = localStorage.getItem(LocalStorageConstants.VERSION);
  if (snapshot) {
    if (localStorageAvailable() && DATA_MODEL_VERSION === version) {
      snapshot = JSON.parse(snapshot);
    } else {
      snapshot = undefined;
    }
  }
  // eslint-disable-next-line no-unused-vars
} catch (e) {
  snapshot = undefined;
}

export default snapshot;
